import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getPermissions } from './get-permissions';
import { permissionsKeys } from './permissions-keys';

import { isNewUser } from '../../../lib/permission-checks';
import type { Permission } from '../permissions.dto';

export const fetchUserPermissions = async (): Promise<Permission[]> => {
  const permissions = await getPermissions();
  if (isNewUser(permissions)) {
    throw new Error('User does not have permissions yet');
  }
  return permissions;
};

export const useWaitUserPermissions = () => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: permissionsKeys.wait(),
    queryFn: async () => {
      const permissions = await fetchUserPermissions();
      // Onboarding just granted permissions — seed the shared cache so guards,
      // nav and the rest read them immediately instead of refetching.
      queryClient.setQueryData(permissionsKeys.all(), permissions);
      return permissions;
    },
    gcTime: 0,
    retry: 3,
    retryDelay: 1000,
    meta: {
      skipGlobalErrorHandling: true,
    },
  });
};
